import { Divider } from '@mui/material'

import { form } from '../../formState'
import * as Texts from '../../intl'
import { ExecutionEventsFormValues } from '../../typings'
import { Props } from './typings'

import { DetectedServiceTime } from './components/DetectedServiceTime'
import { DetectedTime } from './components/DetectedTime'
import { ReportedExecutionDetails } from './components/ReportedExecutionDetails'
import { ReportedStatus } from './components/ReportedStatus'
import { ReportedStatusReason } from './components/ReportedStatusReason'

const secondsInADay = 24 * 60 * 60

const parseTrackingData = (
  values: ExecutionEventsFormValues,
  workingDayStartSec: number,
): ExecutionEventsFormValues => {
  const { timeInSec, timeOutSec, ...rest } = values
  const isOvernight = workingDayStartSec > 0

  return {
    timeInSec:
      isOvernight && timeInSec < workingDayStartSec ? timeInSec + secondsInADay : timeInSec,
    timeOutSec:
      isOvernight && timeOutSec < workingDayStartSec ? timeOutSec + secondsInADay : timeOutSec,
    ...rest,
  }
}

export const ExecutionEvents = (props: Props) => {
  const {
    values,
    rescheduleBehavior,
    workingDayStartSec,
    territory: { statusReasons },
  } = props

  const showStatusReason = values.status === 'reschedule' && statusReasons.length > 0

  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {Texts.getExecutionDetailsTitle()}
      </form.SectionTitle>

      <ReportedExecutionDetails {...props} />

      <ReportedStatus {...props} />

      {showStatusReason && <ReportedStatusReason {...props} />}

      <form.SectionTitle variant="alternative">
        {Texts.getDetectedExecutionDetailsTitle()}
      </form.SectionTitle>

      <DetectedTime trackingData={values} rescheduleBehavior={rescheduleBehavior} />

      <DetectedServiceTime
        trackingData={parseTrackingData(values, workingDayStartSec)}
        rescheduleBehavior={rescheduleBehavior}
      />

      <Divider />
    </form.Fieldset>
  )
}
